import { PlaceTypesNames } from 'app/constants/place.constant';

export const getPlaceCategory = (options) => {
  const { category } = options;
  return PlaceTypesNames[category];
};
